import React__default from 'react';
import { SkeletonBase } from './styles.js';

function Skeleton(props) {
    const { count = 1 } = props;
    return (React__default.createElement(React__default.Fragment, null, Array.from({ length: count }).map((_, index) => (React__default.createElement(SkeletonBase, Object.assign({ key: index }, props))))));
}

export { Skeleton };
